import { httpGET, getPrettyTime } from './utils'
import { API_SNCF_URL, OPEN_DATA_SCNF_URL } from './constants'
import { sncf_api_key } from './api_keys'
import { app_log } from './app_log'


export class TrainStation {
    constructor(localization, type, info) {
        this.localization = localization;
        this.type = type;
        this.info = info;
        this.next_departures = [];
    }

    getUIC() {
        return this.info["uic_ref"];
    }

    fetchNextDeparture() {
        if (this.next_departures.length !== 0) return;
        //TODO: add a switch case according to the operator (SNCF/DB...)
        // hoooo that's a loooooong way home!
        // we need the uic8 of the train station - this can be achieved by calling the ressources.data.sncf.com api
        // we then may call the api.sncf.com to get next departures time
        if (this.info["uic8"] != null) {
            fetchSNCFNextDepartures(this.info["uic8"])
            .then(nd => {
                this.next_departures.splice(0);
                for (const h of nd) this.next_departures.push(h);
            })
            /* eslint-disable no-console */
            .catch(err => console.log(err));
            /* eslint-enable no-console */
        } else if (this.getUIC() != "") { // we need to get uic8 first
            fetchSNCFUIC8(this.getUIC())
            .then((uic8) =>  {
                this.info["uic8_sncf"] = uic8;
                // uic8 we got from open data sncf is still not a valid one for navitia ...:
                this.info["uic8"] = uic8.slice(2);  // trim the two first zeros
                this.fetchNextDeparture();  // will fetch the next departures
            })
            .catch(err => app_log.info(err));
        }
    }
}

// --------------------------
// SNCF API calls functions
// --------------------------
function fetchSNCFUIC8(uic) {
    return new Promise((resolve, reject) => {
        // let's ask the SNCF api what the corresponding UIC8 is
        const url = OPEN_DATA_SCNF_URL + "/?dataset=referentiel-gares-voyageurs&q=uic_code%3A+%5B" + 
                    "00" +
                    uic +
                    "0+TO+" + 
                    "00" +
                    uic +
                    "9%5D&rows=2&sort=gare_alias_libelle_noncontraint";
        httpGET(url)
        .then(data => {
            const res = JSON.parse(data);
            if (res.records.length >= 1) {
                const uic8 = res.records[0].fields.uic_code;
                resolve(uic8);
            } else {
                reject("Cannot retrieve valid UIC8 id for this train station :(");
            }
        })
    });
}

function fetchSNCFNextDepartures(uic8) {
    // then let's call the SNCF API to get next departures:
    
    return new Promise((resolve, reject) => {
        const url = API_SNCF_URL + "/stop_areas/stop_area:SNCF:" + uic8 + "/departures?&data_freshness=realtime&";
        httpGET(url, 
                {name: "Authorization", value: sncf_api_key})
        .then((data) => {
            const res = JSON.parse(data);
            let next_departures = []
            for (const departure of res.departures) {
                const inf = departure.display_informations;
                const dtime = departure.stop_date_time;
                const ds = dtime.base_departure_date_time;
                const bdtime = new Date(ds.slice(0,4) + "-" + ds.slice(4,6) + "-" + ds.slice(6,8) + "T" + ds.slice(9, 11) + ":" + ds.slice(11, 13) + ":" + ds.slice(13, 15));
                const rt_ds = dtime.base_departure_date_time;
                const rtdtime = new Date(rt_ds.slice(0,4) + "-" + rt_ds.slice(4,6) + "-" + rt_ds.slice(6,8) + "T" + rt_ds.slice(9, 11) + ":" + rt_ds.slice(11, 13) + ":" + rt_ds.slice(13, 15));
                let departure_delay_ms = rtdtime - bdtime;
                if ( isNaN(departure_delay_ms) ) departure_delay_ms = 0;
                next_departures.push(
                            {
                                direction: inf.direction,
                                departure_time: bdtime.toString(),
                                departure_time_day_string: bdtime.toString().slice(0, 10),
                                departure_time_hour_string: bdtime.toString().slice(16, 21),
                                departure_delay: getPrettyTime(departure_delay_ms * 1e3),
                                name: inf.name,
                                train_type: inf.commercial_mode
                            });
            }
            resolve(next_departures);
        })
        .catch(err => reject(err));
    });
}

/*
function fetchRouteSchedule(route_id, from_datetime) {
    return new Promise((resolve, reject) => {
    // 20191231T100000
    httpGET(API_SNCF_URL + "/lines/line%3AOCE%3A" + route_id + "/route_schedules?from_datetime=" + from_datetime + "&data_freshness=realtime&",
            {name: "Authorization", value: sncf_api_key})
    .then((data) => {
        const res = JSON.parse(data);
        let route_schedules = {stop_points: []};
        route_schedules["additional_information"] = res.additional_informations;
        for(const row of route_schedules.table.rows) {
            const stop_point = row.stop_point;
            route_schedules.stop_points.push({
                name: stop_point.name,
                coord: stop_point.coord,
            });
        }
        resolve(route_schedules);
    })
    .catch(err => reject(err));
    });
}
*/